module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-durbanville-black.f8b4c162.svg";